// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pricing-card {
    background-color: #1e102d;
    border: 0.5px solid #a36eedd6;
    padding: 20px;
    text-align: center;
    color: white;
    max-width: 565px;
    position: relative;
}

.pricing-card .icon {
    margin-bottom: 10px;
    height: 124px;
    position: absolute;
    left: 35%;
    top: -65px;
}

.pricing-card .icon img {
    max-width: 100%;
    max-height: 100%;
}

.pricing-card .title {
    color: #FFF;
    text-align: center;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 153%;
    margin-top: 75px;
    font-family: "Inter", sans-serif;
}

.pricing-card .subtitle {
    color: #FFF;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 153%;
    margin-bottom: 17px;
    font-family: "Inter", sans-serif;
}

.pricing-card .subscription-type {
    background-color: #9256E8;
    color: #FFF;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    margin: 17px 0 25px;
    padding: 4px 14px;
    border-radius: 74px;
}

.pricing-card ul {
    list-style: none;
    padding: 0;
    margin: 35px 0 20px;
}

.pricing-card li {
    margin-bottom: 24px;
}

.pricing-card .business-type-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.pricing-card .business-type-details {
    text-align: left;
}

.business-type {
    color: #FFF;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    padding-bottom: 10px;
}

.pricing-card .employee-count {
    color: #FFF;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    opacity: 0.6;
    display: flex;
}

.pricing-card .employee-count img {
    height: 23px;
    padding-right: 7px;
}

.pricing-card .price {
    color: #FFF;
    text-align: right;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
    font-family: "Inter", sans-serif;
}

.get-started-button {
    background-color: #00dbba;
    cursor: pointer;
    transition: background-color 0.3s ease;
    color: #242424;
    text-align: center;
    font-size: 18.333px;
    font-style: normal;
    font-weight: 800;
    line-height: 13.333px;
    width: 100%;
    padding: 18px 0px;
    border: 1px solid transparent;
}

.get-started-button:hover {
    background-color: #00c4a6;
}

@media(max-width:768px) {
    .pricing-card .title {
        margin-top: 55px;
    }

    .pricing-card .icon {
        width: 98px;
        /* top: -50%; */
    }

    .pricing-card-wrap {
        padding: 0px 25px;
    }

    .pricing-card .title {
        font-size: 20px;

    }

    .pricing-card .subtitle {
        font-size: 15px;
    }

    .pricing-card .subscription-type {
        font-size: 15px;
        padding: 6px 14px;
    }

    .business-type {
        font-size: 15px;
    }

    .pricing-card .employee-count {
        font-size: 15px;
    }

    .pricing-card .price {
        font-size: 15px;
    }

    .get-started-button {
        font-size: 15px;
        margin-top: 35px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/PricingCard/PricingCard.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,sCAAsC;IACtC,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".pricing-card {\n    background-color: #1e102d;\n    border: 0.5px solid #a36eedd6;\n    padding: 20px;\n    text-align: center;\n    color: white;\n    max-width: 565px;\n    position: relative;\n}\n\n.pricing-card .icon {\n    margin-bottom: 10px;\n    height: 124px;\n    position: absolute;\n    left: 35%;\n    top: -65px;\n}\n\n.pricing-card .icon img {\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.pricing-card .title {\n    color: #FFF;\n    text-align: center;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 153%;\n    margin-top: 75px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.pricing-card .subtitle {\n    color: #FFF;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 153%;\n    margin-bottom: 17px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.pricing-card .subscription-type {\n    background-color: #9256E8;\n    color: #FFF;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 120%;\n    margin: 17px 0 25px;\n    padding: 4px 14px;\n    border-radius: 74px;\n}\n\n.pricing-card ul {\n    list-style: none;\n    padding: 0;\n    margin: 35px 0 20px;\n}\n\n.pricing-card li {\n    margin-bottom: 24px;\n}\n\n.pricing-card .business-type-wrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.pricing-card .business-type-details {\n    text-align: left;\n}\n\n.business-type {\n    color: #FFF;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%;\n    padding-bottom: 10px;\n}\n\n.pricing-card .employee-count {\n    color: #FFF;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%;\n    opacity: 0.6;\n    display: flex;\n}\n\n.pricing-card .employee-count img {\n    height: 23px;\n    padding-right: 7px;\n}\n\n.pricing-card .price {\n    color: #FFF;\n    text-align: right;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%;\n    font-family: \"Inter\", sans-serif;\n}\n\n.get-started-button {\n    background-color: #00dbba;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    color: #242424;\n    text-align: center;\n    font-size: 18.333px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 13.333px;\n    width: 100%;\n    padding: 18px 0px;\n    border: 1px solid transparent;\n}\n\n.get-started-button:hover {\n    background-color: #00c4a6;\n}\n\n@media(max-width:768px) {\n    .pricing-card .title {\n        margin-top: 55px;\n    }\n\n    .pricing-card .icon {\n        width: 98px;\n        /* top: -50%; */\n    }\n\n    .pricing-card-wrap {\n        padding: 0px 25px;\n    }\n\n    .pricing-card .title {\n        font-size: 20px;\n\n    }\n\n    .pricing-card .subtitle {\n        font-size: 15px;\n    }\n\n    .pricing-card .subscription-type {\n        font-size: 15px;\n        padding: 6px 14px;\n    }\n\n    .business-type {\n        font-size: 15px;\n    }\n\n    .pricing-card .employee-count {\n        font-size: 15px;\n    }\n\n    .pricing-card .price {\n        font-size: 15px;\n    }\n\n    .get-started-button {\n        font-size: 15px;\n        margin-top: 35px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
